export default "__VITE_ASSET__DzB7Dx0j__"